export default __webpack_public_path__ + "static/media/25081103.f37d3fd7.png";